.tooltip-wrapper2 {
    display: block;
    position: relative;
}
